import { PermissionsProtectedRoute } from 'client/routes/PermissionsProtectedRoute';
import { Navigate, RouteObject } from 'react-router-dom';
import React from 'react';
import { SIMILAR_COMPANIES_PERMISSIONS } from './permissions/SimilarCompanies';

const SimilarCompaniesPage = React.lazy(
  () => import('./containers/SimilarCompaniesPage')
);

const page = (
  <React.Suspense fallback={undefined}>
    <SimilarCompaniesPage />
  </React.Suspense>
);

export const similarCompaniesRoutes: RouteObject = {
  path: SIMILAR_COMPANIES_PERMISSIONS.path,
  element: (
    <PermissionsProtectedRoute
      pageId={SIMILAR_COMPANIES_PERMISSIONS.pageId}
      currentPath={`/${SIMILAR_COMPANIES_PERMISSIONS.path}`}
    />
  ),
  children: [
    { path: '', element: page },
    { path: ':id', element: page },
    { path: '*', element: <Navigate to="/404" /> },
  ],
};
